/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(window).on('load', function(){
  if($('.wc_product_review_badge').length > 0){
    console.log('inin');
    var ajax_shop_badge_url = $('#th_shop_url').attr('content'), ajax_product_handle = new Array();
    if(typeof ajax_shop_badge_url != 'undefined'){
      ajax_shop_badge_url = ajax_shop_badge_url.replace(/^https?\:\/\//i, '');
    }
    $('.wc_product_review_badge').each(function(idx, val){
      ajax_product_handle.push($(this).data('handle'));
      if(idx === ($('.wc_product_review_badge').length - 1)){
        $.ajax({
          url: '//thimatic-apps.com/product_review/get_review_rating_update.php',
          type: 'post',
          dataType: 'json',
          data: {shop: ajax_shop_badge_url, product_handles: ajax_product_handle},
          success: function(result){
            $('.wc_product_review_badge').html(result.empty.html);
            $.each(result, function(key, value){
              $('.wc_product_review_badge[data-handle="'+key+'"]').html(value.html);
            });
          },
          error: function(XMLHttpRequest, textStatus){
            console.log(XMLHttpRequest);
          }
        });
      }
    });
  }
})